import typeCheck from 'common/util/typeCheck';

import { onLogicSuccess } from 'client/actions/Auth/login';

import { SR_API_ACTION_ROOMMATE_SIGNUP } from 'api/actionTypes';

export default async function roommateSignup({ state, apiClient }, params) {
  typeCheck('params::Object', params);

  const {
    name,
    phone,
    email,
    password,
    shouldUpdatePassword,
    originalRenterPhone,
    skipLogin,
  } = params;

  typeCheck('name::NonEmptyString', name);
  typeCheck('email::Maybe Email', email);
  typeCheck('phone::Phone', phone);
  typeCheck('password::NonEmptyString', password);
  typeCheck('originalRenterPhone::Phone', originalRenterPhone);

  const analyticsSessionId = state.get(['analytics', 'analyticsSessionId']);
  const experimentActiveVariants = state.get(['analytics', 'experiments', 'activeVariants']);
  await apiClient.postWithState({
    action: SR_API_ACTION_ROOMMATE_SIGNUP,
    state: state,
    payload: {
      name,
      phone,
      email,
      password,
      shouldUpdatePassword,
      originalRenterPhone,
      analyticsSessionId,
      skipLogin,
      experimentActiveVariants,
    },
    async onSuccess({ user }) {
      if (!skipLogin) {
        await onLogicSuccess({
          state,
          apiClient,
          user,
        });
      }
    },
  });
}
